var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Misc! "),_vm._l((_vm.charts),function(c){return _c('div',{key:c.title},[_vm._v(" "+_vm._s(c.source)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }